import { cn } from './cn';

interface SpinnerProps {
  /** Visual size. Defaults to `'md'`. */
  size?: 'sm' | 'md' | 'lg';
  /** Optional accessible label. Defaults to "Loading". */
  label?: string;
  /** Optional class names to merge with the default styles. */
  className?: string;
}

const SIZES = {
  sm: 'h-4 w-4 border-2',
  md: 'h-5 w-5 border-2',
  lg: 'h-7 w-7 border-[2.5px]',
} as const;

/** Inline loading spinner. Uses `role="status"` so screen readers announce it. */
export const Spinner = ({ size = 'md', label = 'Loading', className }: SpinnerProps) => {
  return (
    <span
      role="status"
      aria-label={label}
      className={cn(
        'inline-block animate-spin rounded-full border-current border-t-transparent text-current',
        SIZES[size],
        className,
      )}
    />
  );
};
